export const IDENTITY_METHOD_KEY = 'identity-method';
export const IDENTITY_SESSION_KEY = 'national-node-session-id';
export const IDENTITY_DETAILS_KEY = 'identity-details';
export const EMAIL_SESSION_KEY = 'register-email';
export const CREDENTIALS_SESSION_KEY = 'session-credentials';
